import { render, staticRenderFns } from "./ShowFormData.vue?vue&type=template&id=642d7c3c&"
import script from "./ShowFormData.vue?vue&type=script&lang=js&"
export * from "./ShowFormData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports